import React, { Fragment, useEffect } from "react";
import { OidcSecureChat } from "./OidcSecureChat";
import { initializePage } from "./functions/initializePage";
import { Loading } from "./Loading";
import { CssBaseline } from "@mui/material";
import { BrowserRouter, Route } from "react-router-dom";
import { ApmRoutes } from "@elastic/apm-rum-react";
import LoginPage from "./LoginPage";
import AuthorizationErrorPage from "./components/AuthorizationErrorPage";
import { AuthorizationErrorProvider } from "./contexts/AuthorizationErrorContext";
import AuthorizationErrorBoundary from "./components/AuthorizationErrorBoundary";
import { useAvailableModels } from "./hooks/useAvailableModels";
import { useOidcConfigList } from "./hooks/useOidcConfigList";

export const AppContainer = () => {
  useEffect(() => {}, []);
  const availableModelsContext = useAvailableModels();
  const oidcConfigListContext = useOidcConfigList();

  useEffect(() => {
    initializePage();
  }, []);

  return (
    <Loading contexts={[availableModelsContext, oidcConfigListContext]}>
      <Fragment>
        <CssBaseline />
        <AuthorizationErrorProvider>
          <BrowserRouter>
            <AuthorizationErrorBoundary>
              <ApmRoutes>
                <Route path="/" element={<OidcSecureChat />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/unauthorized" element={<AuthorizationErrorPage />} />
              </ApmRoutes>
            </AuthorizationErrorBoundary>
          </BrowserRouter>
        </AuthorizationErrorProvider>
      </Fragment>
    </Loading>
  );
};
